<template>
  <el-dialog
    title="政企协议异常通知"
    width="534px"
    :visible.sync="dialogVisible"
    :before-close="close"
    :close-on-click-modal="false"
    append-to-body
    :show-close="false"
    @open="open"
  >
    <div class="ExceptionDialogBox">
      <el-carousel trigger="click" height="160px" :autoplay="false" @change="carouselChange">
        <el-carousel-item v-for="item in exceptionList" :key="item.agreementId">
          <div class="wrapping">协议名称：{{ item.agreementName }}</div>
          <div class="wrapping">操作类型：{{ item.operateType }}</div>
          <div class="wrapping">记录日期：{{ item.startDate&&item.startDate.split(' ')[0] }} ~ {{ item.endDate&&item.endDate.split(' ')[0] }}</div>
          <div class="wrapping">异常记录数量：{{ item.exceptionRecordCount }}</div>
          <div class="wrapping">请查看日志了解异常详细信息</div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-checkbox v-model="value.isTodayMute" style="margin-right:10px">今日不再提醒</el-checkbox>
      <el-button type="primary" :disabled="disabled" :loading="submitLoading" @click="close">{{ txt }}</el-button>
      <el-button type="primary" @click="checkLog">查看日志</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { updateAgreementExceptionNotice } from '@/api/manage'
import moment from 'moment'
export default {
  name: 'TaskCenter',
  components: { },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    exceptionList: {
      type: Array,
      default: () => { return [] }
    },
    value: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      index: 0,
      count: 5,
      disabled: true,
      txt: '已知悉，稍后处理（5）',

      submitLoading: false
    }
  },
  computed: {
    ...mapState({
    })
  },
  watch: {

  },
  methods: {
    close() {
      this.submitLoading = true
      const form = {
        agreementExcptionNoneDate: '',
        ...this.value
      }
      if (this.value.isTodayMute) {
        form.agreementExcptionNoneDate = moment().format('YYYY-MM-DD HH:mm:ss')
      }
      updateAgreementExceptionNotice(form).then(res => {

      }).finally(() => {
        this.$emit('close')
        this.submitLoading = false
      })
    },
    carouselChange(index) {
      this.index = index
    },
    open() {
      this.count = 5
      this.txt = `已知悉，稍后处理（${this.count}）`
      this.disabled = true
      this.timer = setInterval(() => {
        this.count--
        this.txt = `已知悉，稍后处理（${this.count}）`
        if (this.count === 0) {
          this.disabled = false
          this.txt = `已知悉，稍后处理`
          clearInterval(this.timer)
        }
      }, 1000)
    },
    checkLog() {
      this.$store.commit('user/SET_AGREEMENT_CODE', this.exceptionList[this.index].agreementCode)
      this.$store.commit('user/SET_LOG_DIALOG_VISI', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapping{
  font-size: 14px;
  color: #757575;
  margin-bottom: 10px;
  padding-left: 80px;
}
</style>
<style >
.ExceptionDialogBox .el-carousel__button{
  height: 10px;
  width: 10px;
  border-radius: 50%;
  border: 1px solid #7d7d7d;

}
.ExceptionDialogBox .el-carousel__indicator.is-active button{
  background: #1890ff;
  border-color: #1890ff;
}

</style>
